import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

import Banner from "../components/about/banner"
import Intro from "../components/about/intro"
import Video from "../components/about/video"
import Resolve from "../components/about/resolve"
import Help from "../components/about/help"

import Cta from "../components/about/cta"
import Testimonial from "../components/testimonials/testimonial"
import LatestNews from "../components/news/latest"

import { graphql } from "gatsby"

export const query = graphql`
  {
    allStrapiBlogs {
      edges {
        node {
          Heading
          Slug
          Body
          FeaturedImage {
            publicURL
          }
        }
      }
    }
    strapiAbout {
      Seo {
        metaTitle
        metaDescription
        keywords
      }
      BannerHeading
      BannerBody
      BannerSubHeading
      Ctas {
        ButtonText
        ButtonLink
      }
      CtaStrips {
        ButtonLink
        ButtonText
        Text
        BackgroundImage {
          publicURL
        }
      }
      Intro {
        Heading
        Body
        Image {
          publicURL
        }
      }
      VideoSection {
        Heading
        Body
        Image {
          publicURL
        }
      }
      ResolveHeading
      ResolveBody
      ResolveQuoteImage {
        publicURL
      }
      ImproveHeading
      ImproveBodyOne
      ImproveBodyTwo
      ImproveSummary
      ResolveQuote
      Testimonials {
        Body
        Name
        Company
        Image {
          publicURL
        }
      }
    }
  }
`

const AboutPage = ({ data }) => (
  <Layout slug={`/about`}>
    <Seo
      title={data.strapiAbout.Seo.metaTitle}
      description={data.strapiAbout.Seo.metaDescription}
      keywords={data.strapiAbout.Seo.keywords}
    />
    <Banner data={data.strapiAbout}></Banner>
    <Intro data={data.strapiAbout}></Intro>
    <Video data={data.strapiAbout}></Video>
    <Testimonial data={data.strapiAbout.Testimonials[0]}></Testimonial>
    <Cta data={data.strapiAbout.CtaStrips[0]}></Cta>
    <Resolve data={data.strapiAbout}></Resolve>
    <Help data={data.strapiAbout}></Help>
    <Cta data={data.strapiAbout.CtaStrips[1]}></Cta>
    <LatestNews data={data.allStrapiBlogs.edges}></LatestNews>
  </Layout>
)

export default AboutPage
